module.exports = __webpack_public_path__ + "h5/img/bb1.8612742f.png";